import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import Constants from './helpers/Constants'
import LeafletHelper from './mapping/leaflet/helper/LeafletHelper'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import './assets/css/main.scss'
import { newI18n as i18n } from './i18n'
import { getLocale } from 'src/helpers/language/TranslationHelper'
import primevueLocale from 'src/locales/primevue/primevue-locale'
import vue3GoogleLogin from 'vue3-google-login'
import './libs/geotiffv0.3.6/geotiff.min.js'

import VueGtag from 'vue-gtag'
import Tooltip from 'primevue/tooltip'

const isProduction = import.meta.env.PROD // process.env.NODE_ENV === 'production'

LeafletHelper.init()

const app = createApp(App)
app.use(router)
const pinia = createPinia()
pinia.use(({ store }) => {
  store.router = markRaw(router)
})
app.use(pinia)

app.use(vue3GoogleLogin, {
  clientId:
    '556164700892-rauh8uo4e7nrk1rt51jkt4eo2fbf5v1m.apps.googleusercontent.com'
})

app.use(PrimeVue, {
  ripple: false,
  locale: primevueLocale[getLocale()]
})
app.use(ToastService)
app.use(i18n)
app.directive('tooltip', Tooltip)

if (isProduction) {
  app.use(
    VueGtag,
    {
      config: {
        id: Constants.GOOGLE_ANALYTICS_ID
        // bootstrap: false,
      },
      enabled: false
    },
    router
  )
}

app.mount('#app')
window.vueInstance = app

export default app
